module.exports = __webpack_public_path__ + "resources/img/img_dsm2_en.3d5ed336bef0b536c464cc6973507643.png";